import { render } from "./MainHeader.vue?vue&type=template&id=9da2633e&scoped=true"
const script = {}

import "./MainHeader.vue?vue&type=style&index=0&id=9da2633e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9da2633e"]])

export default __exports__